module.exports = __webpack_public_path__ + "static/media/brocolli.e415a834.svg";